/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Surface_Dock_LabelInputs */

const en_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimized windows`)
};

const ar_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوافذ المصغّرة`)
};

const bn_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ছোট করা উইন্ডো`)
};

const de_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimierte Fenster`)
};

const es_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventanas minimizadas`)
};

const fr_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fenêtres réduites`)
};

const pt_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Janelas minimizadas`)
};

const zh_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已最小化的窗口`)
};

const tr_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simge durumuna küçültülen pencereler`)
};

const ru_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свёрнутые окна`)
};

const pl_surface_dock_label = /** @type {(inputs: Surface_Dock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zminimalizowane okna`)
};

/**
* | output |
* | --- |
* | "Minimized windows" |
*
* @param {Surface_Dock_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const surface_dock_label = /** @type {((inputs?: Surface_Dock_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Surface_Dock_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_surface_dock_label(inputs)
	if (locale === "bn") return bn_surface_dock_label(inputs)
	if (locale === "de") return de_surface_dock_label(inputs)
	if (locale === "es") return es_surface_dock_label(inputs)
	if (locale === "fr") return fr_surface_dock_label(inputs)
	if (locale === "pt") return pt_surface_dock_label(inputs)
	if (locale === "zh") return zh_surface_dock_label(inputs)
	if (locale === "tr") return tr_surface_dock_label(inputs)
	if (locale === "ru") return ru_surface_dock_label(inputs)
	if (locale === "pl") return pl_surface_dock_label(inputs)
	return en_surface_dock_label(inputs)
});